import apiClient from "@/axios.js";
import endpoints from "@/endpoints";
import axios from "axios";
//import store from "../store";
const PREPR_API = process.env.VUE_APP_PREPR_API;

export async function getRecentOverview() {
  const res = await axios.post(PREPR_API, {
    query: `{
            RecentAncestry (slug: "recent-ancestry") { 
                    heading
                    title
                    image { 
                            url
                    }
                    recent_ancestry {
                            title
                            heading
                            image {
                                    url
                            }
                            text
                    }
                    right_section {
                            title
                            heading
                            main_image {
                                    url
                            }
                            text
                            button_text
                    }
            }
    }`
  });
  return res.data.data.RecentAncestry
}

export async function getRecentVersions() {
  const res = await axios.post(PREPR_API, {
    query: `{
        Versions (slug: "recent-ancestry-versions") { 
                title
                heading
                panel_update_versions {
                title
                text
                image {
                  url
                }
                panel_update_versions {
                  title
                  heading
                  image {
                    url
                  }
                  text
                  button_text
                }
              }
              major_version_history {
                      title
                      heading
                      text
                      sub_heading
                      version
              }
      }
    }`
  });
  return res.data.data.Versions
}

export async function getRecentBook() {
  const res = await axios.post(PREPR_API, {
    query: `{
        Book (slug: "recent-ancestry-book") { 
                heading
                pdf_of_your_results_now_available {
                        title
                        heading
                        image {
                                url
                        }
                        text
                }
            }
        }`
  });
  return res.data.data.Book
}

export function getBookPdfDetails() {
  return apiClient.get(endpoints.bookPdf());
}

function createUrlObject(data) {
  const pdfBlob = new Blob([data], { type: "image/pdf" });
  return window.URL.createObjectURL(pdfBlob);
}

function download(pdf, path) {
  const a = document.createElement("a");
  a.href = pdf;
  a.download = path;
  a.click();
}

function createPath(barcode, type) {
  return `${barcode}-${type}.pdf`;
}

export async function getPdf(barcode, type) {
  const res = await apiClient.get(endpoints.bookPdf(type), {
      responseType: "arraybuffer",
      timeout: 0, //
  });
  const pdf = createUrlObject(res.data);
  download(pdf, createPath(barcode, type));
}

